import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CompanyComponent} from './app.component';
import {ListingService} from '../../services/listing.service';
import {CompanyService} from '../../services/company.service';
import {TicketsService} from '../../services/tickets.service';
import {MaterialModule} from '../../../material.module';
import {SharedModule} from '../shared/module';
import {CarouselModule} from '../../component/carousel/module';
import {BambuserPlaylistComponent} from '../../component/bambuser-playlist/app.component';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    CarouselModule,
    BambuserPlaylistComponent,
  ],
  declarations: [CompanyComponent],
  providers: [ListingService, CompanyService, TicketsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CompanyModule {}
